import type { Interval } from '@/shared/lib'
import { addDays, startOfDay } from '@/shared/lib'

/**
 * Сутки целиком: закрывают время чаще всего на весь день — выходной, отпуск,
 * болезнь. Пара часов «уехал за реквизитом» правится в карточке, и там же
 * меняется причина.
 */
export function defaultBlockSlot(day: Date): Interval {
  const startsAt = startOfDay(day)
  return { startsAt, endsAt: addDays(startsAt, 1) }
}
